import { createFeatureSelector, createSelector } from '@ngrx/store';
import { maintenanceFeatureKey, MaintenanceState } from './maintenance.reducer';

export const selectMaintenanceState = createFeatureSelector<MaintenanceState>(maintenanceFeatureKey);
export const getMaintenance = createSelector(selectMaintenanceState, (state) => state.maintenance);

